<style scoped>
.qty-count {
    min-width: 2rem;
    @apply mx-1 py-1 flex items-center justify-center border rounded text-sm self-stretch;
}

@screen sm {
    .qty-count {
        @apply mx-2 px-1 text-base;
    }
}
</style>

<template>
    <div class="inline-flex items-stretch p-0">
        <button
            :disabled="value === min"
            @click="emitInput(-1)"
            class="btn rounded p-1 my-1 focus:outline-none"
        >
            <div class="icon w-3 h-3 sm:w-4 sm:h-4"><remove /></div>
        </button>
        <div
            class="qty-count"
            :class="{ 'border-red bg-red text-white': hasError }"
        >
            {{ value }}
        </div>
        <button
            :disabled="max !== -1 ? value >= max : false"
            @click="emitInput(+1)"
            class="btn rounded p-1 my-1 focus:outline-none"
        >
            <div class="icon w-3 h-3 sm:w-4 sm:h-4"><add /></div>
        </button>
    </div>
</template>

<script>
import add from '../assets/svg/add.svg';
import remove from '../assets/svg/remove.svg';

export default {
    components: { add, remove },
    props: {
        value: { type: Number, default: 0 },
        min: { type: Number, default: 1 },
        max: { type: Number, default: -1 }
    },
    methods: {
        emitInput(delta) {
            this.$emit('input', this.value + delta);
        }
    },
    computed: {
        hasError() {
            return this.value > this.max || this.value < this.min;
        }
    }
};
</script>
